import React from 'react';
import PropTypes from 'prop-types';
import css from './SingleParameter.APP_TARGET.scss';

const SingleParamenter = ({ keyId, keyName, formattedValue, valueName }) => (
    <div className={ css.parametersList } >
        <div className={ css.itemParameters }>
            <span className={ css.itemName } data-aut-id={ `key_${keyId}` }>{ keyName }</span>
            <span className={ css.itemValue } data-aut-id={ `value_${keyId}` }>{ (formattedValue || valueName) }</span>
        </div>
    </div>
);

SingleParamenter.propTypes = {
    keyId: PropTypes.string,
    keyName: PropTypes.string,
    formattedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    valueName: PropTypes.string
};

export default SingleParamenter;
